/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The TransportUi model module.
 * @module model/TransportUi
 * @version 0.0.2
 */
export class TransportUi {
  /**
   * Constructs a new <code>TransportUi</code>.
   * @alias module:model/TransportUi
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TransportUi</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TransportUi} obj Optional instance to populate.
   * @return {module:model/TransportUi} The populated <code>TransportUi</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TransportUi();
      if (data.hasOwnProperty('transportName'))
        obj.transportName = ApiClient.convertToType(data['transportName'], 'String');
      if (data.hasOwnProperty('providerIcon'))
        obj.providerIcon = ApiClient.convertToType(data['providerIcon'], 'String');
      if (data.hasOwnProperty('providerName'))
        obj.providerName = ApiClient.convertToType(data['providerName'], 'String');
      if (data.hasOwnProperty('materialIcon'))
        obj.materialIcon = ApiClient.convertToType(data['materialIcon'], 'String');
      if (data.hasOwnProperty('svgNameIcon'))
        obj.svgNameIcon = ApiClient.convertToType(data['svgNameIcon'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('bookingLink'))
        obj.bookingLink = ApiClient.convertToType(data['bookingLink'], 'String');
    }
    return obj;
  }
}

/**
 * full name of the transport-variant, which allows also hyphen and space, like \"Carsharing Regio.mobil\"
 * @member {String} transportName
 */
TransportUi.prototype.transportName = undefined;

/**
 * @member {String} providerIcon
 */
TransportUi.prototype.providerIcon = undefined;

/**
 * @member {String} providerName
 */
TransportUi.prototype.providerName = undefined;

/**
 * @member {String} materialIcon
 */
TransportUi.prototype.materialIcon = undefined;

/**
 * @member {String} svgNameIcon
 */
TransportUi.prototype.svgNameIcon = undefined;

/**
 * @member {String} description
 */
TransportUi.prototype.description = undefined;

/**
 * @member {String} bookingLink
 */
TransportUi.prototype.bookingLink = undefined;

